import CircularProgress from '@mui/material/CircularProgress'
interface LoadingParams {
  action?: string
}

export default function Loading({ action }: LoadingParams) {
  return (
    <div className="loading">
      <CircularProgress size={20} />
      <div>{action ? action : 'Loading...'}</div>
    </div>
  )
}
